import { useEffect, useState } from 'react';
import { desktop, type AppUpdateState } from '../platform';

/** Desktop only: the app's own update (downloading, ready to restart). Null in a browser. */
export function useAppUpdate(): [AppUpdateState | null, (s: AppUpdateState) => void] {
  const [state, setState] = useState<AppUpdateState | null>(null);
  useEffect(() => {
    if (!desktop) return;
    let alive = true;
    let heard = false;
    desktop.updates.status().then((s) => alive && !heard && setState(s));
    const off = desktop.updates.onChange((s) => {
      heard = true;
      setState(s);
    });
    return () => {
      alive = false;
      off();
    };
  }, []);
  return [state, setState];
}
